import React, { useState, useEffect } from 'react';
import { map, get, size, head, arrayIsNill, isEmpty } from 'lodash';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { object } from 'prop-types';
import { FlexContainer, NotFound, Loading, Drawer, Divider, Text, Icon } from '../../common';
import { Row, Col } from 'antd';
import MediaListener from '../../utils/MediaListener';
import { Main } from 'base-components';
import Filters from './Filters';
import Card from './Card';
import { GET_SALES_CHANNELS } from '../../../queries';
import { Query } from '../../graphql';
import ModalDelete from './ModalDelete';

const AddressesNotifications = ({ session, client }) => {
    const sessionSalesChannels = map(get(session, 'salesChannels', []), ({ id }) => id);
    const [selectedSalesChannels, setSelectedSalesChannels] = useState([]);
    const [selectedSalesChannelsStore, setSelectedSalesChannelsStore] = useState(null);
    const [showMsgSelectFilter, setShowMsgSelectFilter] = useState(size(sessionSalesChannels) > 1);
    const [visibleModalDelete, setVisibleModalDelete] = useState(false);
    const [infoToModalDelete, setInfoToModalDelete] = useState({});
    const toggleModalDelete = () => setVisibleModalDelete(!visibleModalDelete);
    const [selectedCompanyGroup, onChangeSelectedCompanyGroup] = useState({ label: 'Jumbo', value: 'Jumbo' });
    const [drawerEmails, setDrawerEmails] = useState([]);
    const [drawerItemKey, setDrawerItemKey] = useState('');
    const [drawerVisible, setDrawerVisible] = useState(false);

    useEffect(() => {
        setSelectedSalesChannels(sessionSalesChannels);
        setSelectedSalesChannelsStore(null);
    }, [session]);

    useEffect(() => {
        !isEmpty(drawerEmails) && setDrawerVisible(!drawerVisible);
    }, [drawerEmails]);

    const truncateText = (text, sizeToTruncate) => size(text) > sizeToTruncate ? `${text.substring(0, sizeToTruncate - 1)}...` : text;

    const setFormFieldValue = ({ field, value }) => {
        const salesChannelId = value.value;
        switch (field) {
        case 'salesChannel':
            if (size(selectedSalesChannels) > 0) return setSelectedSalesChannelsStore([salesChannelId]);
            return setSelectedSalesChannels([salesChannelId]);
        }
    };

    const updateQueryVariables = () => {
        setShowMsgSelectFilter(!size(selectedSalesChannelsStore) === 0);
        if (!arrayIsNill(selectedSalesChannelsStore)) setSelectedSalesChannels(selectedSalesChannelsStore || selectedSalesChannels);
    };

    const initialSaleChannelSelected = () => {
        let salesChannels = get(session, 'salesChannels');

        if (size(salesChannels) === 1) {
            return {
                id: get(head(salesChannels), 'id'),
                name: `${get(head(salesChannels), 'store')} - ${get(head(salesChannels), 'name')}`
            };
        }
    };

    const cards = [
        { key: 'email_spid', name: 'Compra SPID' },
        { key: 'email_manager', name: 'Compra cliente VIP' },
        { key: 'email_ultravip', name: 'Compra cliente ULTRA VIP ' },
        { key: 'email_alert', name: 'Ontime de preparación' },
        { key: 'email_rejected_orders', name: 'Pedidos rechazados por Shoppers' },
        { key: 'email_low_fill_rate', name: 'Fillrate bajo' },
        { key: 'email_low_found_rate', name: 'Foundrate bajo' },
        { key: 'email_rejected_audits', name: 'Auditorias rechazadas' }
    ];

    return (
        <Main background='#f4f4f4' withFooter>
            <MediaListener values={['16.7%', '100%', '100%']}>
                {({ currentValue }) => {
                    return (
                        <>
                            <Filters
                                onChangeSelectedCompanyGroup={({ value }) => {
                                    onChangeSelectedCompanyGroup(value);
                                }}
                                selectedCompanyGroup={selectedCompanyGroup}
                                currentValue={currentValue}
                                onChangeSalesChannels={({ value }) => {
                                    setFormFieldValue({ field: 'salesChannel', value });
                                }}
                                onChangeFilters={updateQueryVariables}
                                initialSaleChannelSelected={initialSaleChannelSelected()}
                            />
                            <FlexContainer direction='row' background='#f4f4f4' style={{ flexWrap: 'wrap', backgroundColor: '#f4f4f4' }} height='100%'>
                                {showMsgSelectFilter
                                    ? <NotFound
                                        firstTextLine='Aún no se ha realizado una búsqueda, utiliza los filtros.'
                                        icon='find'
                                        iconBackgroundColor='#FFFFFF'
                                        iconColor='#c0c0c0'
                                        iconSize={85}
                                        fontSize={20}
                                        centered
                                    />
                                    : <Query
                                        query={GET_SALES_CHANNELS}
                                        variables={{ filter: { where: `comercial_policy=${head(selectedSalesChannelsStore)}` } }}
                                        fetchPolicy='network-only'
                                    >
                                        {({ data, loading, networkStatus }) => {
                                            return <Loading loading={networkStatus === 4 ? false : loading}>
                                                <Row style={{ width: '100%' }}>
                                                    {map(cards, ({ name, key }) => {
                                                        return (
                                                            <Card
                                                                setDrawerEmails={(emails) => setDrawerEmails(emails)}
                                                                setDrawerItemKey={(itemKey) => setDrawerItemKey(itemKey)}
                                                                comercialPolicy={head(selectedSalesChannelsStore)}
                                                                client={client}
                                                                name={name}
                                                                itemKey={key}
                                                                addresses={head(get(data, 'salesChannels'))}
                                                                setInfoToModalDelete={setInfoToModalDelete}
                                                                setVisibleModalDelete={setVisibleModalDelete}
                                                            />
                                                        );
                                                    })}
                                                </Row>
                                                <Drawer
                                                    values={['25%', '25%', '100%']}
                                                    closable
                                                    title={'Detalle'}
                                                    visible={drawerVisible}
                                                    onClose={() => setDrawerVisible(!drawerVisible)}
                                                >
                                                    <Row gutter={16} style={{ width: '100%' }}>
                                                        {map(drawerEmails, (email, index) => {
                                                            return <Row key={email + index}>
                                                                <Divider style={{ margin: '5px 0px' }} />
                                                                <Row gutter={16}>
                                                                    <Col span={20}>
                                                                        <Text text={truncateText(email, 37)} truncate size={12} />
                                                                    </Col>
                                                                    <Col span={4} style={{ textAlign: 'center' }}>
                                                                        <Icon name='trash' color='#A4C735' size={12} pointer onClick={async () => {
                                                                            setInfoToModalDelete({ email, itemKey: drawerItemKey, addresses: head(get(data, 'salesChannels')) });
                                                                            setVisibleModalDelete(true);
                                                                        }} />
                                                                    </Col>
                                                                </Row>
                                                            </Row>;
                                                        })}
                                                    </Row>
                                                </Drawer>
                                            </Loading>;
                                        }}
                                    </Query>
                                }
                            </FlexContainer>
                            <ModalDelete
                                setDrawerVisible={setDrawerVisible}
                                infoToModalDelete={infoToModalDelete}
                                visible={visibleModalDelete}
                                toggleModal={toggleModalDelete}
                            />
                        </>
                    );
                }}
            </MediaListener>
        </Main>
    );
};

AddressesNotifications.propTypes = {
    session: object,
    client: object
};

export default withRouter(withApollo(AddressesNotifications));
